import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  SectionTitle,
  SectionSubtitle,
  SectionDescription,
  Section,
  SectionContent,
} from '../styles/sections';
import {
  PerksTabBar,
  PerkTab,
  PerksGrid,
  PerkCard,
  PerkCardTop,
  PerkDiscountBadge,
  PerkCategoryTag,
  PerkBusinessName,
  PerkDescription,
  PerkButton,
} from '../styles/perks';
import { ColorBlockSection, ColorBlockContent, FloatingTag } from '../styles/colorBlockHero';

// Placeholder perks/partners — swap for real partner data once agreed.
const categories = ['All', 'Fitness & Wellness', 'Food & Drink', 'Retail', 'Travel', 'Equipment'];

const perks = [
  {
    business: 'PulsePoint Gyms',
    category: 'Fitness & Wellness',
    discount: '20% Off',
    description: 'Discounted memberships at any PulsePoint location nationwide.',
  },
  {
    business: 'Riverside Physio',
    category: 'Fitness & Wellness',
    discount: '15% Off',
    description: 'Priority booking and reduced rates on sports injury treatment.',
  },
  {
    business: 'The Clubhouse Kitchen',
    category: 'Food & Drink',
    discount: '10% Off',
    description: 'Post-match meals and team bookings at a discounted rate.',
  },
  {
    business: 'Brew & Bean',
    category: 'Food & Drink',
    discount: 'Free Coffee',
    description: 'A free coffee for every club member, every Friday.',
  },
  {
    business: 'Fieldwear Co.',
    category: 'Retail',
    discount: '25% Off',
    description: 'Club kit, training wear, and accessories at a team discount.',
  },
  {
    business: 'ProBoot Direct',
    category: 'Retail',
    discount: '15% Off',
    description: 'Discounted boots and footwear for every position.',
  },
  {
    business: 'GoTeam Travel',
    category: 'Travel',
    discount: '10% Off',
    description: 'Group booking discounts for away-day travel and accommodation.',
  },
  {
    business: 'Coachline Minibuses',
    category: 'Travel',
    discount: '£50 Off',
    description: 'Off your first team minibus hire booking.',
  },
  {
    business: 'Ironside Sports Equipment',
    category: 'Equipment',
    discount: '20% Off',
    description: 'Training kit, balls, and match-day equipment for clubs.',
  },
];

function PerksPage() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredPerks =
    activeCategory === 'All' ? perks : perks.filter((perk) => perk.category === activeCategory);

  return (
    <>
      <Helmet>
        <title>Perks | Playfair</title>
        <meta name="description" content="Exclusive discounts from brands and businesses, just for Playfair clubs and members." />
        <link rel="canonical" href="https://playfair.online/perks" />
      </Helmet>

      <ColorBlockSection>
        <FloatingTag style={{ top: '18%', left: '8%', transform: 'rotate(-8deg)' }}>
          20% OFF
        </FloatingTag>
        <FloatingTag style={{ top: '65%', right: '12%', transform: 'rotate(6deg)' }}>
          FREE ITEM
        </FloatingTag>
        <FloatingTag style={{ top: '12%', right: '22%', transform: 'rotate(4deg)' }}>
          £50 OFF
        </FloatingTag>

        <ColorBlockContent>
          <SectionSubtitle style={{ color: '#d1ff94' }}>Member Perks</SectionSubtitle>
          <SectionTitle style={{ color: '#fff' }}>Perks</SectionTitle>
          <SectionDescription style={{ color: '#f0efea', marginBottom: 0, maxWidth: '600px' }}>
            Exclusive discounts from brands and businesses, just for Playfair clubs
            and members.
          </SectionDescription>
        </ColorBlockContent>
      </ColorBlockSection>

      <Section backgroundColor="#f0efea">
        <SectionContent>
          <PerksTabBar>
            {categories.map((category) => (
              <PerkTab
                key={category}
                type="button"
                active={activeCategory === category}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </PerkTab>
            ))}
          </PerksTabBar>

          <PerksGrid>
            {filteredPerks.map((perk) => (
              <PerkCard key={perk.business} whileHover={{ y: -5 }}>
                <PerkCardTop>
                  <PerkCategoryTag>{perk.category}</PerkCategoryTag>
                  <PerkDiscountBadge>{perk.discount}</PerkDiscountBadge>
                </PerkCardTop>
                <PerkBusinessName>{perk.business}</PerkBusinessName>
                <PerkDescription>{perk.description}</PerkDescription>
                <PerkButton type="button">Get Code</PerkButton>
              </PerkCard>
            ))}
          </PerksGrid>
        </SectionContent>
      </Section>
    </>
  );
}

export default PerksPage;
